import React from 'react';


const PaymentSuccess: React.FC = () => {
  return (
    <div className="container">
      <h2>Your payment has been received successfully</h2>
      <a href="https://storyset.com/online" target="_blank" rel="noopener noreferrer">
        Online illustrations by Storyset
      </a>
    </div>
  );
};

export default PaymentSuccess;

